import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WorkspaceRoleModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WorkspaceRoleModel._instance == null) WorkspaceRoleModel._instance = new WorkspaceRoleModel(authManager);
        return WorkspaceRoleModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'projects/workspace-roles', 'projects/workspace-roles/codelist');

        this.entityName = 'projects.WorkspaceRole';
        this.privileges = {
            create: [["adminWorkspace"],["manageWorkspace"]],
            read: [["adminWorkspace"],["manageWorkspace"],["editWorkspace"],["readWorkspace"]],
            update: [["adminWorkspace"],["manageWorkspace"]],
            delete: [["adminWorkspace"],["manageWorkspace"]],
        };

        this.label = 'Workspace Role';
        this.setLabel = 'Workspaces';

        this.browser = {
            name: 'default-projects-workspacerole-browser',
            moduleName: 'default-projects-workspacerole-browser',
            moduleTitle: 'Workspaces',
            moduleStateSlotName: 'default-projects-workspacerole-browser',
        };

        this.editor = {
            name: 'default-projects-workspacerole-editor',
            moduleName: 'default-projects-workspacerole-editor',
            moduleTitle: 'Workspace Role',
            moduleStateSlotName: 'default-projects-workspacerole-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
